import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { GoalCloseIcon } from "@/apps/goals/assets/icons";
import { requestPsmzNotification } from "@/apps/goals/services/psmzApi";
import { useStartupParamsStore } from "@/store/startupParams";
import Button from "@/ui/Button/Button";
import Modal from "@/ui/Modal/Modal";
import cls from "./styles.module.scss";

interface ParticipationLockedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ParticipationLockedModal = ({
  isOpen,
  onClose,
}: ParticipationLockedModalProps) => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { yandexId, hash } = useStartupParamsStore((state) => state.auth);
  const serviceType = useStartupParamsStore((state) => state.serviceType);

  const handlePsmzClick = async () => {
    if (!yandexId || isSubmitting) return;

    setIsSubmitting(true);

    try {
      await requestPsmzNotification({
        yandexId,
        serviceType,
        hash,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      hideHeader
      wrapperClassName={cls.modalWrapper}
      wrapperClosingClassName={cls.modalWrapperClosing}
      contentClassName={cls.modalContent}
      closeAnimationMs={320}
    >
      <div className={cls.sheet}>
        <button
          className={cls.closeButton}
          type="button"
          onClick={onClose}
          aria-label={t("goals.participationLocked.close")}
        >
          <GoalCloseIcon />
        </button>
        <img className={cls.image} src="/goals/goals_with_multi.png" alt="" />
        <div className={cls.copy}>
          <h2 className={cls.title}>
            <span className={cls.titleAccent}>
              {t("goals.participationLocked.titleAccent")}
            </span>
            <br />
            {t("goals.participationLocked.title")}
          </h2>
          <p className={cls.subtitle}>
            {t("goals.participationLocked.subtitle")}
          </p>
        </div>
        <Button
          className={cls.button}
          label={t("goals.participationLocked.button")}
          onClick={handlePsmzClick}
          disabled={!yandexId}
          loading={isSubmitting}
        />
      </div>
    </Modal>
  );
};
